export default "__VITE_ASSET__701e581b__"